import { getCourses } from "../../providers/firebaseHandler";
import Loader from "../../components/Dialog/Loader";

import React, { Component, useState, useEffect, useContext } from "react";
import {
  Route,
  Switch,
  withRouter,
  Redirect,
  Link,
  useLocation,
} from "react-router-dom";
import { connect } from "react-redux";
import firebase from "firebase/app";
import "firebase/firestore";
import LanguageRow from "../../components/LanguageRow/LanguageRow";
import axios from "axios";
import AddCourseDialog from "../../components/Dialog/AddCourse";
import {
  addCourse,
  updateCourse,
  deleteCourse,
  addLanguage,
  deleteLanguage,
  getUsersByLanguage,
  getUsers,
  addUser,
  updateUserLanguage,
} from "../../providers/firebaseHandler";
import { Languages } from "../../providers/dataLanguages";
import { FirebaseContext } from "../../providers/firebaseContextProvider";
import AddUserByLangaugeDialog from "../../components/Dialog/AddUserByLangauge";
import AddExistingUserByLangaugeDialog from "../../components/Dialog/AddExistingUserByLangauge";
import { DataGrid } from "@material-ui/data-grid";
import { Popper, Box, Paper } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useHistory } from "react-router-dom";
import { UserContext } from "../../providers/userDataProvider";
import { auth } from "../../firebase";
import { UserType } from "../../providers/config.js";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

//Rendercell
function isOverflown(element) {
  return true;
  // return (
  //   element.scrollHeight > element.clientHeight ||
  //   element.scrollWidth > element.clientWidth
  // );
}

const GridCellExpand = React.memo(function GridCellExpand(props) {
  const { width, value } = props;
  const wrapper = React.useRef(null);
  const cellDiv = React.useRef(null);
  const cellValue = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showFullCell, setShowFullCell] = React.useState(false);
  const [showPopper, setShowPopper] = React.useState(false);
  const [showEntryForm, setShowEntryForm] = React.useState(false);

  const handleMouseEnter = () => {
    const isCurrentlyOverflown = isOverflown(cellValue.current);
    setShowPopper(isCurrentlyOverflown);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  };

  const handleMouseLeave = () => {
    setShowFullCell(false);
  };

  React.useEffect(() => {
    if (!showFullCell) {
      return undefined;
    }
    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") {
        setShowFullCell(false);
      }
    }
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [setShowFullCell, showFullCell]);

  return (
    <Box
      ref={wrapper}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        alignItems: "center",
        lineHeight: "36px",
        position: "relative",
        display: "flex",
        paddingRight: 10,
        width: "100%",
      }}
    >
      <Box
        ref={cellDiv}
        sx={{
          width,
          display: "block",
          position: "absolute",
          top: 0,
        }}
      />
      <Box
        ref={cellValue}
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {value}
      </Box>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
          style={{ width, marginLeft: -17 }}
        >
          <Paper
            elevation={1}
            style={{ minHeight: wrapper.current.offsetHeight - 3 }}
          >
            <Typography variant="body2" style={{ padding: 8 }}>
              {value}
            </Typography>
          </Paper>
        </Popper>
      )}
    </Box>
  );
});

// GridCellExpand.propTypes = {
//   value: PropTypes.string.isRequired,
//   width: PropTypes.number.isRequired,
// };

function renderCellExpand(params) {
  return (
    <GridCellExpand
      value={params.value || ""}
      width={params.colDef.computedWidth}
    />
  );
}
//

const transformLanguage = (dataStr) => {
  return dataStr.toLowerCase();
  //return dataStr[0].toUpperCase() + dataStr.slice(1).toLowerCase();
};

function LanguageDashboard(props) {
  
  
  const verticalMargin = "20px";
  let history = useHistory();
  const language = props.match.params.language;
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const userContext = useContext(UserContext);
  const [showEntryForm, setShowEntryForm] = useState(false);
  let leadRole = false;
  let editRole = false;
  let viewerRole = false;
  if (userContext.user.lead) {
    leadRole = userContext.user.lead.includes(transformLanguage(language));
  }
  const [isLead, setIsLead] = useState(leadRole);
  if (userContext.user.edit) {
    editRole = userContext.user.edit.includes(transformLanguage(language));
  }
  const [isEditor, setIsEditor] = useState(editRole);
  if (userContext.user.view) {
    viewerRole = userContext.user.view.includes(transformLanguage(language));
  }
  const [isViewer, setIsViewer] = useState(viewerRole);
  const [radioValue, setRadioValue] = useState("lang");
  const [showUserForm, setShowUserForm] = useState(false);
  const [showExistingUserForm, setShowExistingUserForm] = useState(false);
  const [updateFlag, setUpdateFlag] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [filteredUserArray, setFilteredUserArray] = useState([]);
  const [usersArray, setUsersArray] = React.useState([]);
  const [allUsersArray, setAllUsersArray] = React.useState([]);
  const firebaseContext = useContext(FirebaseContext);
  const addCourseData = async (data) => {
    setShowEntryForm(false);
    let obj = {
      id: data.id,
      name: data.name,
      description: data.description,
      teaching: data.language,
      availWeb: false,
      availMobile: false,
      words: [],
    };
    swal
      .fire({
        title: "Are you sure you want to add new course?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, add it!",
      })
      .then(async (result) => {
        setLoading(true);
        let res = await addCourse(obj);
        setLoading(false);
        if (res === "done") {
          toast.success("Added successfully!");
        } else {
          toast.success("Something went wrong. try again!");
        }
      });
    setLoading(false);
  };
  const getValue = (params) => {
    if (params.value) {
      let isSet = params.value.includes(transformLanguage(language));
      return isSet ? "Yes" : "No";
    } else {
      return "No";
    }
  };

  const userColumns = [
    // {
    //   field: "edituser",
    //   headerName: "Edit",
    //   width: 150,
    //   sortable: false,
    //   renderCell: (params) => {
    //     const onClick = (e) => {
    //       e.stopPropagation(); // don't select this row after clicking
    //       const api = params.api;
    //       const thisRow = {};
    //       api
    //         .getAllColumns()
    //         .filter((c) => c.field !== "__check__" && !!c)
    //         .forEach(
    //           (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
    //         );
    //       history.push("/" + thisRow.name + "/Dashboard/");

    //       // return alert(JSON.stringify(thisRow, null, 4));
    //     };

    //     return (
    //       <Button variant="contained" onClick={onClick}>
    //         Edit User
    //       </Button>
    //     );
    //   },
    // },
    { field: "name", headerName: "Name", width: 150 },
    { field: "email", headerName: "Email", width: 150 },
    {
      field: "active",
      headerName: "Active",
      width: 150,
      valueGetter: (params) => (params.value ? "Yes" : "No"),
    },
    // {
    //   field: "lead",
    //   headerName: "Lead",
    //   valueGetter: getValue,
    //   renderCell: renderCellExpand,
    //   width: 200
    // },
    {
      field: "edit",
      headerName: "Editor",
      valueGetter: getValue,
      renderCell: renderCellExpand,
      width: 250,
    },
    {
      field: "view",
      headerName: "Viewer",
      valueGetter: getValue,
      renderCell: renderCellExpand,
      flex: 1,
    },
  ];

  const langColumns = [
    {
      field: "edit",
      headerName: "View",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          //history.push("/course/" + params.row.id + "/Dashboard/");
          history.push({
            pathname: "/course/" + params.row.id + "/Dashboard/",
            state: { isEditor: isEditor, isViewer: isViewer, isLead: isLead },
          });
        };
        return (
          <Button variant="contained" onClick={onClick}>
            View Course
          </Button>
        );
      },
    },
    { field: "name", headerName: "Name", flex: 1 },
  ];
  const handleChange = (event) => {
    setRadioValue(event.target.value);
  };
  /////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////// USERS MANAGEMENT ///////////////////////////////
   const addExistingUserData = async (data) => {
    setShowUserForm(false);
    let role = "";
    if (data.edit.length > 0) {
      role = UserType.editor;
    } else {
      role = UserType.viewer;
    }
    let obj = {
      id: data.id,
      edit: data.edit,
      view: data.view,
      role,
    };
    swal
      .fire({
        title: "Are you sure you want to add " + data.name + "?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, add it!",
      })
      .then(async (result) => {
        setLoading(true);
        let res = await updateUserLanguage(obj);
        setLoading(false);
        if (res === "done") {
          let usersData = await getUsersByLanguage(language);
          setUsersArray(usersData);
          setLoading(false);
          toast.success("Added successfully!");
        } else {
          toast.success("Something went wrong. try again!");
        }
      });
    setLoading(false);
  };
  const addUserData = async (data) => {
    setShowUserForm(false);
    let role = "";
    if (data.lead.length > 0) {
      role = UserType.lead;
    } else if (data.edit.length > 0) {
      role = UserType.editor;
    } else {
      role = UserType.viewer;
    }
    let obj = {
      email: data.email,
      password: data.password,
      name: data.name,
      lead: data.lead,
      edit: data.edit,
      view: data.view,
      active: true,
      role,
    };
    swal
      .fire({
        title: "Are you sure to add new User?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, add it!",
      })
      .then(async (result) => {
        setLoading(true);
        let res = await addUser(obj);
        if (res === "done") {
          let usersData = await getUsersByLanguage(language);
          setUsersArray(usersData);
          setLoading(false);
          toast.success("Added successfully!");
        } else {
          toast.success("Something went wrong. try again!");
        }
      });
    setLoading(false);
  };
  const updateUserData = async (data) => {
    setShowUserForm(false);
    let role = "";
    if (data.edit.length > 0) {
      role = UserType.editor;
    } else {
      role = UserType.viewer;
    }
    let obj = {
      id: data.id,
      edit: data.edit,
      view: data.view,
      role,
    };
    swal
      .fire({
        title: "Are you sure to update " + data.name + "?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, update it!",
      })
      .then(async (result) => {
        setLoading(true);
        let res = await updateUserLanguage(obj);
        setLoading(false);
        if (res === "done") {
          let usersData = await getUsersByLanguage(language);
          setUsersArray(usersData);
          setLoading(false);
          toast.success("Update successfully!");
        } else {
          toast.success("Something went wrong. try again!");
        }
      });
    setLoading(false);
  };
  const deleteUserData = async (data) => {
    setShowUserForm(false);

    let obj = {
      id: data.name,
      name: data.name,
      about: data.about,
      region: data.region,
      availWeb: data.availWeb,
      availMobile: data.availMobile,
      availTrans: data.availTrans,
    };
    swal
      .fire({
        title: "Are you sure to delete " + data.name + "?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      })
      .then(async (result) => {
        setLoading(true);
        let res = await deleteLanguage(obj);
        setLoading(false);
        if (res === "done") {
          toast.success("Deleted successfully!");
        } else {
          toast.success("Something went wrong. try again!");
        }
      });
    setLoading(false);
  };
  function updateUserRow(event, params) {
    if (
      userContext.user.role === UserType.superAdmin ||
      userContext.user.role === UserType.lead
    ) {
      setSelectedData(params.row);
      setUpdateFlag(true);
      setShowUserForm(true);
    } else {
      alert("You are not authorized.");
    }
  }
  function updateRow(event, params) {
    if (userContext.user.role === UserType.superAdmin) {
      setSelectedData(params.row);
      setUpdateFlag(true);
      setShowEntryForm(true);
    } else {
      alert("You are not authorized.");
    }
  }
  /////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(async () => {
    loadCourses();
    let usersData = await getUsersByLanguage(language);
    setUsersArray(usersData);
    let allUsersData = await getUsers();
    setAllUsersArray(allUsersData);
  }, []);

  const loadCourses = async () => {
    setLoading(true);
    let data = await getCourses(language);
    if (data != "error") {
      setCourses(data);
    }
    setLoading(false);
  };
  return (

    <div style={{ justifyContent: "flex-end" }}>
      <div
        style={{
          marginTop: verticalMargin,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <Loader loading={loading} />
        <Typography variant="h4" component="h2">
          {language} Courses Dashboard
        </Typography>
        {userContext.user.role === UserType.superAdmin || isLead ? (
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              value={radioValue}
              onChange={handleChange}
            >
              <FormControlLabel
                value="lang"
                control={<Radio />}
                label="Courses"
              />
              <FormControlLabel
                value="users"
                control={<Radio />}
                label="User Management"
              />
            </RadioGroup>
            {(userContext.user.role === UserType.superAdmin || isLead ) &&radioValue == "lang" && (
              <Button
                variant="contained"
                onClick={(e) => {
                  setSelectedData({});
                  setUpdateFlag(false);
                  setShowEntryForm(true);
                }}
              >
                Add a Course
              </Button>
              
            )}
               {showEntryForm ? (
          <AddCourseDialog language={language}
            okCallback={(data) => {
              addCourseData(data);
            }}
            updateCallback={(data) => {
              updateCourse(data);
            }}
            cancelCallback={() => {
              setShowEntryForm(false);
            }}
            row={selectedData}
            visible={showEntryForm}
            updateFlag={updateFlag}

          ></AddCourseDialog>
        ) : (
          <></>
        )}
            {radioValue != "lang" && (
              <div
                style={{
                  flexDirection: "row",
                }}
              >
                <Button
                  variant="contained"
                  onClick={async (e) => {
                    setLoading(true)
                    let usersData = await getUsersByLanguage(language);
                    usersData.push(userContext.user)
                    
                    let allUsersData = await getUsers();
                    let filteredUsers = allUsersData.filter((user) => {
                      let uid = user.id;
                      for (let i = 0; i < usersData.length; i++) {
                        if (usersData[i].id == uid) {
                          return false;
                        }
                      }
                      return true;
                    });
                     setLoading(false)
                    setFilteredUserArray(filteredUsers)
                    setSelectedData({});
                    setUpdateFlag(false);
                     setShowExistingUserForm(true);
                   
                  }}
                >
                  Add a User
                </Button>
                <Button
                  style={{ marginLeft: 20 }}
                  variant="contained"
                  onClick={(e) => {
                    setSelectedData({});
                    setUpdateFlag(false);
                     setShowUserForm(true);
                  }}
                >
                  Create a User
                </Button>
              </div>
            )}
          </FormControl>
        ) : (
          <></>
        )}
        {radioValue == "lang" && (
          
          <div
            style={{
              marginTop: verticalMargin,
              justifyContent: "center",
              width: "95%",
              height: "80vh",
              backgroundColor: "#EDF5E1",
            }}

          >
          <div>
           
            </div>
            <DataGrid
              hideFooter
              style={{ width: "100%" }}
              onCellDoubleClick={(params, event) => {
                updateRow(event, params);
              }}
              rows={courses}
              columns={langColumns}
              pageSize={100}
              disableColumnMenu
            />
          </div>
        )}
        {showUserForm && (
          <AddUserByLangaugeDialog
            okCallback={(data) => {
              addUserData(data);
            }}
            cancelCallback={() => {
              setShowUserForm(false);
            }}
            updateCallback={(data) => {
              updateUserData(data);
            }}
            deleteCallback={(data) => {
              deleteUserData(data);
            }}
            multiSelectRowData={firebaseContext.languages}
            row={selectedData}
            visible={showUserForm}
            updateFlag={updateFlag}
            language={language}
          ></AddUserByLangaugeDialog>
        )}
        {showExistingUserForm && (
          <AddExistingUserByLangaugeDialog
            okCallback={(data) => {
              //console.log(data)
              setShowExistingUserForm(false);
              addExistingUserData(data);
            }}
            cancelCallback={() => {
              setShowExistingUserForm(false);
            }}
            row={filteredUserArray}
            visible={showExistingUserForm}
            language={language}
          ></AddExistingUserByLangaugeDialog>
        )}
        {radioValue != "lang" && (
          <div
            style={{
              marginTop: verticalMargin,
              justifyContent: "center",
              width: "95%",
              height: "80vh",
              backgroundColor: "#EDF5E1",
            }}
          >
            <DataGrid
              // onCellEnter={handleCellEnter}
              hideFooter
              // headerHeight={20}
              // rowHeight={25}
              style={{ width: "100%" }}
              // onCellClick={CellonClick}
              onCellDoubleClick={(params, event) => {
                updateUserRow(event, params);
              }}
              rows={usersArray}
              columns={userColumns}
              pageSize={100}
              disableColumnMenu
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default LanguageDashboard;
